<template>
    <div class="ota_search_index">
        <!-- 标题 -->
        <div class="search_title">
            <div class="search_title_text">OTA搜索</div>
            <div class="search_title_border">
                <div class="bread_crumbs_before_left"></div>
                <div class="bread_crumbs_before_right"></div>
            </div>
        </div>
        <!-- 搜索框 -->
        <div class="search_leaf_node">
            <input 
                type="text" 
                v-model="search_val" 
                placeholder="请输入OTA关键字"
                @keyup.enter="searchFn"
            />
            <div class="search_leaf_button" @click="searchFn"></div>
        </div>

        <!-- 搜索结果列表 -->
        <div class="ota-detail-list" v-if="searchResult.length">
            <div class="detail-list">
                <div class="detail-item" v-for="(item, index) in searchResult" :key="item.id">
                    <div class="detail-item-title">{{ index + 1 }}.{{ item.intro }}</div>
                    <div class="detail-content">{{ item.content }}</div>
                    <div class="detail-item-main">
                        <template v-for="img in item.attachment" :key="img.id">
                            <el-image v-if="img.type === 1" class="detail-img" :src="img.link_url"
                                :preview-src-list="[img.link_url]" fit="cover" />
                            <div v-else-if="img.type === 2" class="detail-video-wrapper" @click.stop="previewVideo(item.attachment.filter(a => a.type === 2))">
                                <div class="detail-video-thumb">
                                    <video controlsList="nodownload" :src="img.link_url"
                                        :poster="img.link_url + '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'"
                                        preload="none"></video>
                                </div>
                                <div class="look_pic">点击查看视频</div>
                            </div>
                        </template>
                    </div>
                    <div class="detail-item-model">
                        <div>{{ item.brand.name }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ item.model }}</div>
                        <div class="detail-item-model-date">{{ item.published }}</div>
                    </div>
                    <div class="sp-line"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="my_swiper_dialog" v-if="swiperVisible">
        <div class="my_swiper_dialog_content">
            <div class="my_swiper_dialog_close" @click="closeSwiperDialog"></div>
            <swiper :list="preview_list" :type="preview_type" />
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { ElMessage, ElImage } from 'element-plus'
import { getOtaSearch } from '@/api'
import Swiper from "@/components/swiper/Swiper.vue"

export default {
    components: {
        ElImage,
        Swiper
    },
    name: 'OtaSearchIndex',
    setup() {
        const search_val = ref('')
        const loading = ref(false)
        const searchResult = ref([])

        const searchFn = () => {
            if (!search_val.value.trim()) {
                ElMessage.warning("请输入搜索内容！")
                return
            }
            loading.value = true
            
            getOtaSearch({
                keyword: search_val.value
            }).then(res => {
                searchResult.value = res.data.list || []
                loading.value = false
            }).catch(() => {
                loading.value = false
            })
        }

        const swiperVisible = ref(false);
        const preview_list = ref([]);
        const preview_type = ref("img");
        const previewImg = (list, type) => {
            preview_list.value = list;
            preview_type.value = type;
            swiperVisible.value = true;
        };
        const previewVideo = (attachmentList) => {
            // 将 attachment 数组转换为 previewImg 需要的格式
            const videoList = attachmentList.map(item => ({
                attach_value: item.link_url
            }));
            previewImg(videoList, 'video');
        };
        const closeSwiperDialog = () => {
            document.querySelectorAll("video").forEach((item) => {
                item.pause();
            });
            swiperVisible.value = false;
        };

        return {
            search_val,
            loading,
            searchResult,
            searchFn,
            previewImg,
            previewVideo,
            swiperVisible,
            closeSwiperDialog,
            preview_list,
            preview_type
        }
    }
}
</script>

<style lang="less" scoped>
.ota_search_index {
    width: 1200px;
    background: #fff;
    padding: 20px 40px;
    min-height: calc(100vh - 100px);

    .search_title {
        position: relative;
        height: 46px;
        line-height: 46px;
        .search_title_text {
            font-size: 14px;
            font-weight: bold;
            color: #0E0A31;
            text-align: center;
        }
        .search_title_border {
            display: flex;
            align-items: center;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            .bread_crumbs_before_left {
                width: 28px;
                height: 2px;
                background: #1FBCBF;
            }
            .bread_crumbs_before_right {
                width: 27px;
                height: 2px;
                background: #DCDCDC;
            }
        }
    }

    .search_leaf_node {
        margin: 30px auto 10px;
        width: 692px;
        height: 52px;
        border-radius: 2px;
        border: 1px solid #DEDEDE;
        background-position: 179px center;
        display: flex;
        align-items: center;
        font-size: 16px;

        input {
            width: 100%;
            height: 100%;
            appearance: none;
            outline: none;
            border: none;
            background: transparent;
            padding: 0 10px 0 30px;
            font-size: 14px;
            &::placeholder{
                color: #bebebe;
            }
        }

        &:has(input:focus){
            border: 1px solid #1FBCBF;
        }

        .search_leaf_button {
            width: 50px;
            height: 100%;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ssh_20221229.png)
                no-repeat center center;
            background-size: 17px 17px;
            cursor: pointer;
        }
    }
}

.ota-detail-list {
    margin-top: 50px;
    overflow-y: auto;
    max-height: calc(100vh - 200px);
}

.detail-list {
    max-width: 1080px;
}

.detail-content {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #404248;
    font-style: normal;
    margin-top: 12px;
}

.detail-img {
    margin-top: 16px;
    height: 140px;
    margin-right: 25px;
}

.detail-video-wrapper {
    margin-top: 16px;
    margin-right: 25px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;

    .detail-video-thumb {
        width: 140px;
        height: 140px;
        position: relative;
        overflow: hidden;
        border-radius: 4px;

        video {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .look_pic {
        margin-top: 8px;
        font-size: 12px;
        color: #5287ea;
        line-height: 16px;
    }
}

.detail-item-main {
    display: flex;
}

.sp-line {
    height: 1px;
    width: 100%;
    background: #d0d0d0;
    margin: 20px 0;
    opacity: 0.5;
}

.detail-item-model {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #8b909d;
    font-style: normal;
    margin-top: 10px;
    width: 600px;
    border: 1px solid #ccc;
    padding: 5px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
}

.my_swiper_dialog {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 5000;

    .my_swiper_dialog_content {
        width: auto;
        height: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        .my_swiper_dialog_close {
            width: 50px;
            height: 50px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png) no-repeat center center;
            background-size: 50px 50px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 40px;
            position: absolute;
            top: 40px;
            right: 40px;
            z-index: 2;
            cursor: pointer;
        }
    }
}
</style>